export interface AuxModalState {
  width: string;
  height: string;
}

export const initialState: AuxModalState = {
  width: '550px',
  height: '628px',
};
